<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'CityMain',
    data () {
      return {
        cityDetailsSubscriptionId: null
      }
    },
    computed: {
      city () {
        var selectedCity = {
          abbreviation: this.$route.params.abbreviation,
          name: this.$route.params.abbreviation
        };
        this.$store.state.cities.forEach(city => {
            if (city.abbreviation === this.$route.params.abbreviation) {
              selectedCity = city;
              this.$store.commit('setContextName', city.name);
              this.$store.commit('setCurrentCity', city);
            }
          }
        );

        if (this.cityDetailsSubscriptionId) {
          this.$store.api.unsubscribe(this.cityDetailsSubscriptionId);
        }

        if (selectedCity.versionedId)
          this.cityDetailsSubscriptionId = this.$store.api.subscribe("CITY_DETAILS", selectedCity.versionedId.id, this.cityDetailsChangeHandler);

        return selectedCity
      },
      cityDetails() {
        return this.$store.state.currentCityDetails;
      }
    },
    watch: {
      city: function(newCity) {
        // Make sure city gets computed...
      }
    },
    beforeDestroy() {
      if (this.cityDetailsSubscriptionId) {
        this.$store.api.unsubscribe(this.cityDetailsSubscriptionId);
      }
      this.cityDetailsSubscriptionId = null;
    },
    methods: {
      cityDetailsChangeHandler(newCityDetails) {
        this.$store.commit('setCityDetails', newCityDetails);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CityMain.vue